export default __webpack_public_path__ + "static/linkedin-cover-photo-size-3bb4331dfa33b52e3122f1179ebf3be0.jpg";